import { IAnimSimpleStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';
import { Action } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/element-animation/anim-constants';

export interface IAttr extends IAnimSimpleStyle {
    filterAction?: Action;
    filterType?: string;
    filterRate?: number;
}

interface IAnimE2EManager {
    setElementStartAttrMap(order: number, elementAttrMap: Record<string, IAttr>): void;
    getElementStartAttrObj(order: number): Record<string, IAttr> | undefined;
    dispose(): void;
}

export default class AnimE2EManager implements IAnimE2EManager {
    private static instance: IAnimE2EManager;
    public static getInstance(): IAnimE2EManager {
        if (!this.instance) {
            this.instance = new AnimE2EManager();
        }

        return this.instance;
    }

    private startAttrMap: Map<number, Record<string, IAttr>> = new Map();

    public setElementStartAttrMap(order: number, elementAttrMap: Record<string, IAttr>) {
        this.startAttrMap.set(order, elementAttrMap);
    }

    public getElementStartAttrObj(order: number): Record<string, IAttr> | undefined {
        return this.startAttrMap.get(order);
    }

    public dispose() {
        this.startAttrMap.clear();
    }
}
